import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { IframeCommunicationService } from './_common/services/iframe-communication.service';
import { GiftcardEditDialogComponent } from './_common/dialogs/giftcard-edit-dialog/giftcard-edit-dialog.component';

@Component({
	selector: 'azc-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
	public isLoading: boolean;
	private messageSubscription: Subscription;

	constructor(
		private router: Router, 
		private title: Title,
		private dialog: MatDialog,
		private iframeCommunication: IframeCommunicationService
	) {
	}

	ngOnInit() {
		this.router.events.subscribe((e: RouterEvent) => this.handleNavigationChange(e));
		this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((n: NavigationEnd) => {
			window.scrollTo(0, 0);

			const pageTitle = this.getTitle(this.router.routerState.snapshot.root);
			if (pageTitle) {
				this.title.setTitle(pageTitle);
			} else {
				this.title.setTitle('AmazingCo.');
			}
		});

		// Listen for messages from embedded iframes (e.g., ac-hub)
		this.messageSubscription = this.iframeCommunication.message$.subscribe(message => {
			this.handleIframeMessage(message);
		});
	}

	ngOnDestroy() {
		if (this.messageSubscription) {
			this.messageSubscription.unsubscribe();
		}
	}

	private handleIframeMessage(message: any) {
		switch (message.type) {
			case 'OPEN_GIFTCARD_EDIT':
				if (message.giftcardId) {
					this.openGiftcardEditDialog(message.giftcardId);
				}
				break;
		}
	}

	private openGiftcardEditDialog(giftcardId: string) {
		this.dialog.open(GiftcardEditDialogComponent, {
			width: '90vw',
			maxWidth: '1200px',
			height: '90vh',
			data: { giftcardId },
			disableClose: false
		});
	}

	getTitle(route: ActivatedRouteSnapshot): string {
		if (route.firstChild) {
			return this.getTitle(route.firstChild) || route.data['title'];
		}
		return route.data['title'];
	}

	// Shows and hides the loading spinner during RouterEvent changes
	handleNavigationChange(event: RouterEvent): void {
		if (event instanceof NavigationStart) {
			this.isLoading = true;
		}
		if (event instanceof NavigationEnd) {
			this.isLoading = false;
		}

		// Set loading state to false in both of the below events to hide the spinner in case a request fails
		if (event instanceof NavigationCancel) {
			this.isLoading = false;
		}
		if (event instanceof NavigationError) {
			this.isLoading = false;
		}
	}
}
